import { ConfigType } from "../utils/requestAPI";

const scrape = {
  getScrape: (link: string, landlordId: any): ConfigType => {
    return {
      method: "post",
      url: "properties/url",
      data: {
        link,
        landlord: landlordId,
      },
    };
  },
};

export default scrape;
